import React, { Component } from 'react';
import Controls from '../../util/controls';
import TradingHours from 'bambora-trading-hours';
import 'bambora-trading-hours/assets/index.css';
import _ from 'underscore';

class MerchantDetails extends Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        return (
            <div>
                <h2>Your Profile</h2>
                <div className="card">
                    <table className="table table-striped m-b-0">
                        <tbody>
                            <tr>
                                <th>Business Name</th> 
                                <td>{this.props.details.name}</td>
                            </tr>
                            <tr>
                                <th>Contact No.</th> 
                                <td>{this.props.details.phoneNumber}</td>
                            </tr>
                            <tr>
                                <th>Merchant ID</th> 
                                <td>{this.props.details.merchantId}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h4>Business Address</h4>
                <div className="card text-center"> 
                    <address>
                        <i className="fa fa-map-marker" /> <strong>{this.props.details.name}</strong><br />
                        {this.props.details.address}<br />
                        {(this.props.details.address2 || "").trim() ? (
                            <span>{this.props.details.address2}<br /></span>
                        ) : null}
                        {this.props.details.city}, {this.props.details.state}, {this.props.details.postcode}
                    </address>
                </div>

                <h4>Trading Hours</h4>
                <div className="card">
                    {!this.props.tradingHoursLoading ? (
                        <div>
                            <TradingHours
                                style={{ table: 'table table-striped f-s-12', input: 'form-control', inputLabel: 'help-block', invalid: 'has-error' }} 
                                handleHoursChange={this.props.onTradingHoursChange}
                                hours={this.props.tradingHours} />
                            <button 
                                className="btn btn-client btn-lg btn-block" 
                                onClick={this.props.onTradingHoursSubmit} 
                                disabled={_.any(this.props.tradingHours, (t) => t.openHours && t.isValid === false)}
                                type="button">
                                Update Trading Hours
                            </button>
                        </div>
                    ) : (
                        <Controls.LoadingPanel />
                    )}
                </div>
            </div>
        );
    }
}


export default MerchantDetails;


// WEBPACK FOOTER //
// ./app/profile/components/merchantDetails.js